class QuoteService {
    lastError;
    lastResponseCode;

    constructor(axios) {
        this.axios = axios
    }

    async getHistoricQuote(currency, isin, date) {
        const url = '/api/quotes/historic'

        const config = {
            params: {
                currency: currency,
                isin: isin,
                date: date
            }
        }

        return await this.axios
            .get(url, config)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    handleError(e) {
        console.log(e)

        this.lastResponseCode = e.response?.status
        this.lastError = e.response?.statusText

        throw new Error(this.lastError)
    }
}

export default QuoteService
